import { render, staticRenderFns } from "./wageAppeal.vue?vue&type=template&id=7051a320&scoped=true&"
import script from "./wageAppeal.vue?vue&type=script&lang=js&"
export * from "./wageAppeal.vue?vue&type=script&lang=js&"
import style0 from "./wageAppeal.vue?vue&type=style&index=0&id=7051a320&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051a320",
  null
  
)

export default component.exports